export default "__VITE_ASSET__DVyF2k2K__"